export const storeProducts = [{
        id: 1,
        title: "Sunfeast Dark Fantasy",
        quantity: '75 g',
        img: "img/product01.jpeg",
        price: 27,
        company: "Sunfeast",
        info: "The buiscuit from Sunfeast, best flavour and healty product. Ingredients: Choco Creme, Sugar, Refined Palm Oil, Cocoa Solids, Vegetable Oil, Invert Syrup",
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 2,
        title: "Oreo Chocolatey",
        quantity: '50 g',
        img: "img/product02.jpeg",
        price: 9,
        company: "Oreo",
        info: "The vanila flavoured buiscuit, known for the test. It's too tasty and healty. Ingredients: Refined Wheat Flour, Sugar, Edible Vegetable Fat, Palmolein Oil, Invert Syrup, Cocoa Solids, Leavening Agents, Edible Salt",
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 3,
        title: "Unibic Assorted Cookies",
        quantity: '450 g, Pack of 6',
        img: "img/product03.jpeg",
        price: 8,
        company: "Unibic",
        info: "The super save pack of tastie cookies. Ingredients: Wheat Flour, Sugar, Edible Vegetable OIl, Milk Solids, Liquid Solids, Edible Common Salt, Leavening Agents, Emulsifiers",
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 4,
        title: "Britannia Premium Rusk",
        quantity: "273 g",
        img: "img/product04.jpeg",
        price: 38,
        company: "Britannia",
        info: "The favourite of indian family toasts. Taste to believe, Ingredients: Refined Wheat Flour, Sugar, Edible Oil, Yeast, Invert Sugar Syrup, Milk Solids, Butter, Edible Common Salt, Spices,",
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 5,
        title: "Parle Monaco Biscuits",
        quantity: "200 g",
        img: "img/product05.jpeg",
        price: 29,
        company: "Parle",
        info: "The old is gold. Parle best one ever buiscuit. Ingredients: Wheat Flour, Edible Vegetable Oils (Palm Oil, Palmolein Oil), Sugar, Raising Agents, Invert Sugar Syrup, Edible Common Salt, Yeast, Acidity Regulators, Emulsifiers, Dough Conditioner and Improver Amylase & Other Enzymes",
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 6,
        title: "Dukes Utsav Danish Cookies",
        quantity: "400 g",
        img: "img/product06.jpeg",
        price: 279,
        company: "Dukes",
        info: "Decison is yours, The best of taste. Ingredients: Refined Wheat Flour, Sugar, Interesterifled,Vegetable Fat, Butter (4%), Liquid Glucose, Milk Solids, Edible Common Salt, Raising Agents (503 [ii], Baking Powder), Emulsifier (322)",
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 7,
        title: "Dukes Masala Nibbles",
        quantity: "150 g",
        img: "img/product07.jpeg",
        price: 47,
        company: "Dukes",
        info: "Taste to belive. Salted buiscuit, The crispy flavoured. Ingredients: Refined Wheat Flour, Refined Palm Oil, Sugar, Refined Palmolein, Sugar Solution, Edible Common Salt",
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 8,
        title: "Britannia Good Day Cookies",
        quantity: "150 g",
        img: "img/product08.jpeg",
        price: 21,
        company: "Britannia",
        info: "The food for foody. Ingredients: Refined Wheat Flour, Edible Vegetable Oil, Butter, Invert Syrup",
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 9,
        title: "Parle Hide & Seek Black Bourbon",
        quantity: "100 g",
        img: "img/product09.jpeg",
        price: 24,
        company: "Parle",
        info: "The old is gold. Parle best one ever buiscuit. Ingredients: Sugar, Wheat Flour, Edible Vegetable Oil, Cocoa Solids, Invert Sugar Syrup, Edible Common Salt, Raising Agents and Emulsifier",
        inCart: false,
        count: 0,
        total: 0
    }
];

export const detailProduct = {
    id: 1,
    title: "Sunfeast Dark Fantasy",
    quantity: "75 g",
    img: "img/product01.jpeg",
    price: 10,
    company: "Sunfeast",
    info: "The buiscuit from Sunfeast, best flavour and healty product. Ingredients: Choco Creme, Sugar, Refined Palm Oil, Cocoa Solids, Vegetable Oil, Invert Syrup",
    inCart: false,
    count: 0,
    total: 0
};